import { MediaFlex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled from "styled-components"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

const KlarnaContainer = styled(MediaFlex).attrs((props) => ({
  alignItems: { _: "center", tablet: "flex-end" },
  flexDirection: { _: "column", tablet: "row" },
  maxWidth: { desktop: "280px", tablet: "250px" },
  minHeight: { _: "38px", tablet: "21px" },
  ...props,
}))``

const Klarna = ({ price }) => {
  useEffect(() => {
    if (window.Klarna && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }, [price])

  if (!enableKlarnaCheckout() || price <= 0) {
    return null
  }

  const locale = `en-${sl.config.site_country_for_analytics}`

  return (
    <>
      <KlarnaContainer lessThan="tablet">
        <klarna-placement
          data-key="credit-promotion-badge"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer>
      <KlarnaContainer greaterThanOrEqual="tablet">
        <klarna-placement
          data-key="credit-promotion-auto-size"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer>
    </>
  )
}

Klarna.propTypes = {
  price: PropTypes.number,
}

export default Klarna
